if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        this.filterImgVariant();
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      filterImgVariant() {
        if(this.currentVariant.featured_media && this.currentVariant.featured_media.alt) {
            document.querySelectorAll('[thumbnail-alt]').forEach(img => img.style.display = 'none')
            const currentImgAlt = this.currentVariant.featured_media.alt
            const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`
            document.querySelectorAll(thumbnailSelector).forEach(img => img.style.display = 'block')
        } else {
            document.querySelectorAll('[thumbnail-alt]').forEach(img => img.style.display = 'block')
        }
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

class WishlistUpdater {
  constructor() {
    this.relatedProductsContainer = document.querySelector(".section_related_product");
    this.init();
  }

  updateWishlist() {
    // console.log("Related Products Updated!");

    const cards = document.querySelectorAll(".section_related_product .card-information");

    if (cards.length > 0) {
      frcp.wishlist.attachOnCollection();
      // console.log("Wishlist attached successfully!");
      
      // START: ||-------------------->>> FRCP_WL Snippet - Modify the  <<<--------------------||
      const allWishlistIconsFrcp = document.querySelectorAll(".frcp-wishlist__icon");
      allWishlistIconsFrcp.forEach(function (wishlistIcon) {
        if (wishlistIcon.innerHTML.includes("M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z")) {
          wishlistIcon.outerHTML = `
            <svg class="frcp-wishlist__icon" preserveAspectRatio="xMidYMid slice" width="24" heigth="24" height="24"
              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="inherit" stroke="inherit">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.238L17 20V4H7v16l5-4.762zm-4 2.429l4-3.81 4 3.81V5H8v12.667z">
              </path>
            </svg>
          `;
        }
      });
      // END: ||-------------------->>> FRCP_WL Snippet <<<--------------------||
    } else {
      console.log("No .card-information elements found yet.");
    }
  }

  init() {
    if (this.relatedProductsContainer) {
      const observer = new MutationObserver(() => {
        this.updateWishlist();
      });

      observer.observe(this.relatedProductsContainer, { childList: true, subtree: true });
    }

    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.classList.contains("section_related_product")) {
        this.updateWishlist();
      }
    });
  }
}

// Initialize the class
new WishlistUpdater();


document.addEventListener("DOMContentLoaded", function() {
    function rearrangeElements() {
        const productDetails = document.querySelector('.divider');
        const productDetailsSub = document.querySelector('.sub-divider');
        const colorLabel = document.querySelector('variant-selects');
        const productForm = document.querySelector('.product-form');
        const wishlist = document.querySelector('.sub-div__right');

        // if (productDetails && productTitle && productPrice && productTax && colorLabel && productForm) {
        if (productDetails && productDetailsSub && colorLabel && productForm) {
            const gridContainer = document.createElement('div');
            gridContainer.style.display = 'grid';
            gridContainer.style.gridTemplateColumns = 'minmax(0,2.5fr) minmax(0,1.5fr)';
            gridContainer.style.gap = '10px';
            gridContainer.style.overflowX = 'hidden';
            gridContainer.style.paddingBottom = '10px';
          
            const leftColumn = document.createElement('div');
            leftColumn.style.display = 'flex';
            leftColumn.style.flexDirection = 'column';
            leftColumn.appendChild(productDetailsSub);

            const rightColumn = document.createElement('div');
            rightColumn.classList.add('right-column');
            rightColumn.style.overflowX = 'auto';
            rightColumn.style.display = 'block';
            rightColumn.style.justifyContent = 'flex-end';
            rightColumn.style.maskImage = 'linear-gradient(to right, rgba(202, 6, 6, 0), rgba(0, 0, 255, 1) 5%, rgba(0, 0, 255, 1) 95%, rgba(235, 9, 9, 0))';
            colorLabel.style.whiteSpace = 'nowrap';

            rightColumn.appendChild(colorLabel);

            gridContainer.appendChild(leftColumn);
            gridContainer.appendChild(rightColumn);

            productDetails.parentNode.replaceChild(gridContainer, productDetails);

            const secondGridContainer = document.createElement('div');
            secondGridContainer.style.display = 'grid';
            secondGridContainer.style.gridTemplateColumns = '4fr 0.5fr';
            secondGridContainer.style.gap = '10px';
            // secondGridContainer.style.paddingTop = '20px';

            const formColumn = document.createElement('div');
            formColumn.style.display = 'flex';
            formColumn.style.flexDirection = 'column';
          
            const wishlistColumn = document.createElement('div');
            wishlistColumn.style.textAlign = 'right';
            wishlistColumn.style.display = 'flex';
            wishlistColumn.style.justifyContent = 'center';
            wishlistColumn.style.borderLeft = '0.5px solid #000';
            wishlistColumn.style.borderRight = '0.5px solid #000';
          
            formColumn.appendChild(productForm);
            wishlistColumn.appendChild(wishlist);

            // Append both columns to the second grid container
            secondGridContainer.appendChild(formColumn);
            secondGridContainer.appendChild(wishlistColumn);

            // Append the product-form below the grid container
            // gridContainer.parentNode.insertBefore(productForm, gridContainer.nextSibling);
            gridContainer.parentNode.insertBefore(secondGridContainer, gridContainer.nextSibling);

            productForm.style.textAlign = 'center';

            let startX;
            let scrollLeft;
            let isUserScrolling = false;
            let scrollSpeed = 1; // Adjust auto-scroll speed
            let autoScrollInterval;
            let userScrollTimeout;

            function startAutoScroll() {
                autoScrollInterval = setInterval(() => {
                    if (!isUserScrolling) {
                        rightColumn.scrollLeft += scrollSpeed;
                        // Loop back to the start if it reaches the end
                        // if (rightColumn.scrollLeft + rightColumn.clientWidth >= rightColumn.scrollWidth) {
                        //     rightColumn.scrollLeft = 0; // Reset scroll to the beginning
                        // }
                        if (rightColumn.scrollLeft + rightColumn.clientWidth >= rightColumn.scrollWidth) {
                            stopAutoScroll(); // Stop the auto-scroll when the end is reached
                        }
                    }
                }, 60);
            }

            function stopAutoScroll() {
                clearInterval(autoScrollInterval);
            }

            rightColumn.addEventListener('touchstart', function(e) {
                startX = e.touches[0].pageX;
                scrollLeft = rightColumn.scrollLeft;
                isUserScrolling = true; // Pause auto-scroll while user is scrolling
                stopAutoScroll(); // Immediately stop auto-scroll on touch
            });

            rightColumn.addEventListener('touchmove', function(e) {
                const touch = e.touches[0];
                const walk = (startX - touch.pageX) * 0.5; // Reduced scroll speed for smoothness
                rightColumn.scrollLeft = scrollLeft + walk;
            });

            rightColumn.addEventListener('touchend', function() {
                clearTimeout(userScrollTimeout);
                
                userScrollTimeout = setTimeout(() => {
                    isUserScrolling = false;
                    startAutoScroll();
                }, 30000);
            });

            startAutoScroll();
        }
    }

    function checkScreenSize() {
        if (window.innerWidth <= 749) {
            rearrangeElements();
        }
    }

    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);
});


document.addEventListener('DOMContentLoaded', () => {
  const wrapElement = () => {
    const element = document.querySelector('.product-detail-images__image-bar');
    if (!element) return;

    const isMobile = window.innerWidth <= 749;
    const wrapper = element.closest('.mob_position');

    if (isMobile && !wrapper) {
      const newWrapper = document.createElement('pos');
      newWrapper.className = 'mob_position';
      element.parentNode.insertBefore(newWrapper, element);
      newWrapper.appendChild(element);
    } else if (!isMobile && wrapper) {
      while (wrapper.firstChild) wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
      wrapper.remove();
    }
  };

  wrapElement();
  window.addEventListener('resize', wrapElement);
});






document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(min-width: 750px)').matches) {
    let startX = 0;
    let startY = 0;
    let threshold = 20;
    // let prevProductSvg1 = document.querySelector('.product-url svg g');
    // let prevProductSvg2 = document.querySelector('#productNextImageWrapper');
  
    // if (prevProductSvg1) {
    //     prevProductSvg1.style.display = 'none';
    // }
    // if (prevProductSvg2) {
    //     prevProductSvg2.style.display = 'none';
    // }
  
    function handleSwipeNavigation(direction) {
        if (direction === 'left') {
            if (typeof productNextUrl !== 'undefined' && productNextUrl) {
                window.location.href = productNextUrl;
            } else {
                console.log("No next product URL available.");
            }
        } else if (direction === 'right') {
            if (typeof productPrevUrl !== 'undefined' && productPrevUrl) {
                window.location.href = productPrevUrl;
            } else {
                console.log("No previous product URL available.");
            }
        }
    }

    function isSwipeWithinTargets(target) {
        return target.closest('.product-detail-images__image-barone') || 
               target.closest('.product__info-wrapper');
    }

    document.addEventListener('touchstart', function (event) {
        if (isSwipeWithinTargets(event.target)) {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
        }
    });

    document.addEventListener('touchend', function (event) {
        if (isSwipeWithinTargets(event.target)) {
            let endX = event.changedTouches[0].clientX;
            let endY = event.changedTouches[0].clientY;

            let diffX = endX - startX;
            let diffY = endY - startY;

            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
                if (diffX > 0) {
                    handleSwipeNavigation('right');
                } else {
                    handleSwipeNavigation('left');
                }
            }
        }
    });

    if (typeof runProductPrevNextProduct === 'function') {
        runProductPrevNextProduct([jQuery]);
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(max-width: 749px)').matches) {
    let style = document.createElement('style');
    style.innerHTML = `
        .main_section_footer {
            transition: transform 0.7s, opacity 0.7s;
        }
        .main_section_footer.swipe-left {
            transform: translateX(-100%) rotateY(-30deg);
            opacity: 1;
        }
        .main_section_footer.swipe-right {
            transform: translateX(100%) rotateY(30deg);
            opacity: 1;
        }
        .main_section_footer.new-page {
            transform: translateX(0) rotateY(0deg);
            opacity: 1;
        }
    `;
    document.head.appendChild(style);

    let startX = 0;
    let startY = 0;
    let threshold = 20;

    function handleSwipeNavigation(direction) {
        let mainSection = document.querySelector('.main_section_footer');

        if (direction === 'left') {
            mainSection.classList.add('swipe-left');
            setTimeout(function () {
                if (typeof productNextUrl !== 'undefined' && productNextUrl) {
                    window.location.href = productNextUrl;
                } else {
                    console.log("No next product URL available.");
                }
            }, 500);
        } else if (direction === 'right') {
            mainSection.classList.add('swipe-right');
            setTimeout(function () {
                if (typeof productPrevUrl !== 'undefined' && productPrevUrl) {
                    window.location.href = productPrevUrl;
                } else {
                    console.log("No previous product URL available.");
                }
            }, 500);
        }
    }

    function isSwipeWithinTargets(target) {
        return target.closest('.product-detail-images__image-barone');
    }

    document.addEventListener('touchstart', function (event) {
        if (isSwipeWithinTargets(event.target)) {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
        }
    });

    document.addEventListener('touchend', function (event) {
        if (isSwipeWithinTargets(event.target)) {
            let endX = event.changedTouches[0].clientX;
            let endY = event.changedTouches[0].clientY;

            let diffX = endX - startX;
            let diffY = endY - startY;

            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
                if (diffX > 0 && typeof productPrevUrl !== 'undefined' && productPrevUrl) {
                    handleSwipeNavigation('right');
                } else if (diffX < 0 && typeof productNextUrl !== 'undefined' && productNextUrl) {
                    handleSwipeNavigation('left');
                }
            }
        }
    });

    if (typeof runProductPrevNextProduct === 'function') {
        runProductPrevNextProduct([jQuery]);
    }
  }
});


$(document).on('touchstart', '[id^="ModalClose-"]', function(event) {
  event.preventDefault();
  event.stopPropagation();

  let touchStartX = event.originalEvent.touches[0].clientX;
  let touchStartY = event.originalEvent.touches[0].clientY;

  $(document).on('touchend', function(e) {
    event.preventDefault();
    event.stopPropagation();

    let touchEndX = e.originalEvent.changedTouches[0].clientX;
    let touchEndY = e.originalEvent.changedTouches[0].clientY;

    if (Math.abs(touchStartX - touchEndX) < 10 && Math.abs(touchStartY - touchEndY) < 10) {
      $('.media-modal').removeAttr('open');
    }
  });
});





document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 750) {
    function disableScroll() {
      document.body.style.overflow = 'hidden';
    }
    
    function moveWithHoverYaxis() {
      const imgElement = document.querySelector('.product-media-modal__content img.active');
    
      if (!imgElement) return;

      disableScroll();
  
      imgElement.addEventListener('mouseenter', function() {
      });
    
      imgElement.addEventListener('mousemove', function(event) {
        const imgHeight = imgElement.offsetHeight;
        const modalHeight = imgElement.parentElement.offsetHeight;
        const rect = imgElement.getBoundingClientRect();
    
        const mouseY = event.clientY - rect.top;
    
        const yPercent = (mouseY / imgHeight) * 100;
    
        const translateY = (yPercent * (modalHeight - imgHeight)) / 100;
    
        imgElement.style.transform = `translateY(${translateY}px)`;
      });
    
      imgElement.addEventListener('mouseleave', function() {
        imgElement.style.transform = 'translateY(0)'; // Reset to the initial position
      });
    }
    
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target.classList.contains('active')) {
          moveWithHoverYaxis();
        }
      });
    });
  
    const imgContainer = document.querySelector('.product-media-modal__content');
    if (imgContainer) {
      observer.observe(imgContainer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }
});




$(document).ready(function () {
  function getNavTarget() {
    var asNavFor = $(".product-detail-images__image-barone ul");
    return asNavFor && asNavFor.length ? asNavFor : null;
  }

  $(".product-detail-images__image-bar ul li").on("click", function () {
    var index = $(this).index();
    var navTarget = getNavTarget();

    if (navTarget) {
      var target = navTarget.find("li").eq(index);
      if (target.length) {
        target[0].scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      }
    }
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var index = $(entry.target).index();
        $(".product-detail-images__image-bar ul li").css("opacity", "0.5");
        $(".product-detail-images__image-bar ul li").removeClass("opacity_sel");
        $(".product-detail-images__image-bar ul li").eq(index).css("opacity", "1");
        $(".product-detail-images__image-bar ul li").eq(index).addClass("opacity_sel");
      }
    });
  }, {
    root: $(".product-detail-images__image-barone ul")[0],
    threshold: 0.5
  });

  $(".product-detail-images__image-barone ul li").each(function() {
    observer.observe(this);
  });
});


document.addEventListener("DOMContentLoaded", function() {
    function rearrangeElements() {
        document.querySelectorAll('fieldset').forEach(fieldset => {
            const legend = fieldset.querySelector('legend');
            if (legend && legend.childNodes[0].nodeValue.trim().toLowerCase() === 'size:') {
                fieldset.style.display = 'grid';
                fieldset.style.gridTemplateColumns = 'repeat(2, 1fr)';
                fieldset.style.columnGap = '4px';
                fieldset.style.rowGap = '4px';
            }
        });
    }

    function checkScreenSize() {
        if (window.innerWidth > 750) {
            rearrangeElements();
        }
    }

    // Initial check when the DOM is loaded
    checkScreenSize();

    // Event listener for window resize
    window.addEventListener("resize", function() {
        checkScreenSize(); // Check screen size when the window is resized
    });
});




// pincode availability

// Optimized Pincode Availability Script
const csvFileUrl = 'https://cdn.shopify.com/s/files/1/0793/6514/4769/files/Delhivery_Shipment_Pincode.csv?v=1729855882';
let pincodeData = {};

// Load pincode data and parse CSV efficiently
async function loadPincodeData() {
  try {
    const response = await fetch(csvFileUrl);
    const data = await response.text();
    data.split("\n").forEach(row => {
      const [pincode, surface] = row.split(",");
      if (pincode && surface) {
        pincodeData[pincode.trim()] = +surface.trim();
      }
    });
  } catch (error) {
    console.error("Error loading pincode data:", error);
  }
}

// Calculate delivery date
function calculateDeliveryDate(days) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' });
}

// Check and display pincode delivery time
function checkPincode(inputPincode) {
  const trimmedPincode = inputPincode.trim();
  if (trimmedPincode && trimmedPincode.length === 6) {
    if (pincodeData[trimmedPincode]) {
      const estimatedDelivery = calculateDeliveryDate(pincodeData[trimmedPincode]);
      $('#e_d_time').text(`You will receive by ${estimatedDelivery}`).show();
    } else {
      $('#e_d_time').text("Pincode non-serviceable | Try Another One").show();
    }
  } else {
    $('#e_d_time').hide();
  }
}

// Event listeners
$(document).ready(async function () {
  await loadPincodeData();

  // Pincode input handler
  $('#pincode').on('input', function () {
    const input = $(this).val();
    if (input.length === 6) {
      checkPincode(input);
    } else {
      $('#e_d_time').hide().text('');
    }
  });

  // Reset button handler
  $('#check-pincode').on('click', function () {
    $('#pincode').val('');
    $('#e_d_time').hide().text('');
  });
});


document.addEventListener("DOMContentLoaded", function () {
    const navContainer = document.querySelector(".nav-container");

    function scrollToActive(behavior = "instant") {
        const activeItem = document.querySelector(".prev-col.active");

        if (navContainer && activeItem) {
            requestAnimationFrame(() => {
                activeItem.scrollIntoView({
                    behavior,
                    block: "nearest",
                    inline: "center"
                });
            });
        }
    }

    setTimeout(() => scrollToActive("instant"), 10);

    document.querySelectorAll(".prev-col").forEach((item) => {
        item.addEventListener("click", function () {
            setTimeout(() => scrollToActive("smooth"), 10);
        });
    });
});





document.addEventListener("DOMContentLoaded", function () {
  const footerSection = document.querySelector(".main_section_footer");
  const relatedProducts = document.querySelector(".related-products_prev-col");

  if (!footerSection || !relatedProducts) return;

  footerSection.addEventListener("scroll", function () {
    if (window.innerWidth > 750) {
      if (footerSection.scrollTop > 0) {
        relatedProducts.classList.add("nav-hidden");
      } else {
        relatedProducts.classList.remove("nav-hidden");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function removeRelatedProducts() {
    const relatedProducts = document.querySelector(".related-products_prev-col");
    const progressBar = document.querySelector(".progress-bar");
    const productDescription = document.querySelector(".product_description_desktop");
    
    if (window.innerWidth < 749) {
      if (relatedProducts) relatedProducts.remove();
      if (progressBar) progressBar.remove();
      if (productDescription) productDescription.remove();

      // Remove event listener after all elements are removed
      if (!document.querySelector(".related-products_prev-col") &&
          !document.querySelector(".progress-bar") &&
          !document.querySelector(".product_description_desktop")) {
        window.removeEventListener("resize", removeRelatedProducts);
      }
    }
  }

  // Run on initial load
  removeRelatedProducts();

  // Add event listener if any of the elements exist
  if (document.querySelector(".related-products_prev-col") ||
      document.querySelector(".progress-bar") ||
      document.querySelector(".product_description_desktop")) {
    window.addEventListener("resize", removeRelatedProducts);
  }
});


window.addEventListener('load', function() {
  const images = document.querySelectorAll('.product-media-modal__content img');
  images.forEach(function(image) {
    image.setAttribute('loading', 'lazy');
  });
});



// (() => {
//   const modal = document.querySelector('product-modal');
//   const el = document.querySelector('.product-media-modal__content-mobile');
//   const container = el?.parentElement; // .product-media-modal__dialog
//   if (!modal || !el || !container) return;

//   const state = {
//     x: 0, y: 0,
//     scale: 1.2,         // default zoom
//     minScale: 0.9,
//     maxScale: 4,
//     closeThreshold: 1.2 // auto-close if scale < 1.2
//   };

//   // ---- helpers ----
//   const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
//   const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

//   function containerRect() { return container.getBoundingClientRect(); }
//   function baseSize() { 
//     // size of content at scale 1 (ignores current transform)
//     return { w: el.offsetWidth, h: el.offsetHeight };
//   }

//   // Keep content fully covering container; center if content is smaller.
//   function clampToBounds(next = { x: state.x, y: state.y, scale: state.scale }) {
//     const { width: cw, height: ch } = containerRect();
//     const { w: bw, h: bh } = baseSize();
//     const sw = bw * next.scale;
//     const sh = bh * next.scale;

//     // If content is smaller than container, center it.
//     if (sw <= cw) {
//       next.x = (cw - sw) / 2;
//     } else {
//       const minX = cw - sw;  // content's right edge aligned with container's right
//       const maxX = 0;        // content's left edge aligned with container's left
//       next.x = clamp(next.x, minX, maxX);
//     }

//     if (sh <= ch) {
//       next.y = (ch - sh) / 2;
//     } else {
//       const minY = ch - sh;
//       const maxY = 0;
//       next.y = clamp(next.y, minY, maxY);
//     }
//     return next;
//   }

//   // rAF apply
//   let rafId = null;
//   function applyTransform() {
//     rafId = null;
//     const clamped = clampToBounds();
//     state.x = clamped.x;
//     state.y = clamped.y;
//     el.style.transform = `translate3d(${state.x.toFixed(3)}px, ${state.y.toFixed(3)}px, 0px) scale(${state.scale.toFixed(5)})`;
//   }
//   function scheduleApply(){ if (!rafId) rafId = requestAnimationFrame(applyTransform); }

//   // Center-focused zoom math (zoom around container center)
//   function zoomAroundCenter(nextScale) {
//     const rect = containerRect();
//     const cx = rect.left + rect.width / 2;
//     const cy = rect.top  + rect.height / 2;

//     // Given S0,T0 -> S1,T1 and focal f, keep content under f stable:
//     // T1 = f - (S1/S0) * (f - T0)
//     const scaleFactor = nextScale / state.scale || 1;
//     const newX = cx - scaleFactor * (cx - state.x);
//     const newY = cy - scaleFactor * (cy - state.y);

//     state.scale = nextScale;
//     const clamped = clampToBounds({ x: newX, y: newY, scale: state.scale });
//     state.x = clamped.x; state.y = clamped.y;
//     scheduleApply();
//   }

//   // ---- gesture handling ----
//   const pointers = new Map();
//   const start = { x: 0, y: 0, scale: 1, dist: 0, panX: 0, panY: 0 };

//   function onPointerDown(e){
//     el.setPointerCapture(e.pointerId);
//     pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

//     if (pointers.size === 1){
//       start.x = state.x; start.y = state.y;
//       start.panX = e.clientX; start.panY = e.clientY;
//     } else if (pointers.size === 2){
//       start.x = state.x; start.y = state.y;
//       start.scale = state.scale;
//       const [p1, p2] = [...pointers.values()];
//       start.dist = dist(p1, p2);
//     }
//   }

//   function onPointerMove(e){
//     if (!pointers.has(e.pointerId)) return;
//     pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

//     if (pointers.size === 1){
//       // pan
//       const p = [...pointers.values()][0];
//       const nx = start.x + (p.x - start.panX);
//       const ny = start.y + (p.y - start.panY);
//       const clamped = clampToBounds({ x: nx, y: ny, scale: state.scale });
//       state.x = clamped.x; state.y = clamped.y;
//       scheduleApply();
//     } else if (pointers.size >= 2){
//       // pinch zoom -> focus on center (not pointer midpoint)
//       const [p1, p2] = [...pointers.values()];
//       const currentDist = Math.max(1, dist(p1, p2));
//       if (!start.dist) start.dist = currentDist;

//       const rawScale = start.scale * (currentDist / start.dist);
//       const newScale = clamp(rawScale, state.minScale, state.maxScale);

//       zoomAroundCenter(newScale);

//       if (state.scale < state.closeThreshold) closeProductModal();
//     }
//   }

//   function onPointerUp(e){
//     if (pointers.has(e.pointerId)) pointers.delete(e.pointerId);
//     if (pointers.size === 1){
//       const p = [...pointers.values()][0];
//       start.x = state.x; start.y = state.y;
//       start.panX = p.x; start.panY = p.y;
//     } else if (pointers.size === 2){
//       start.x = state.x; start.y = state.y; start.scale = state.scale;
//       const [a,b] = [...pointers.values()];
//       start.dist = dist(a,b);
//     }
//   }

//   // trackpad / wheel zoom -> also center-focused
//   function onWheel(e){
//     if (!e.ctrlKey && Math.abs(e.deltaY) < 1) return;
//     e.preventDefault();
//     const zoomFactor = 0.0015;
//     const target = clamp(state.scale * (1 - e.deltaY * zoomFactor), state.minScale, state.maxScale);
//     zoomAroundCenter(target);
//     if (state.scale < state.closeThreshold) closeProductModal();
//   }

//   // close behavior
//   function closeProductModal(){
//     if (modal.__closing) return;
//     modal.__closing = true;
//     el.style.transition = 'transform 0.2s ease-out, opacity 0.2s ease-out';
//     el.style.opacity = '0';
//     el.style.transform = 'translate3d(0,0,0) scale(0.92)';
//     setTimeout(() => {
//       modal.removeAttribute('open');
//       el.style.transition = ''; el.style.opacity = ''; el.style.transform = '';
//       modal.__closing = false;
//     }, 200);
//   }

//   // init
//   el.style.transform = `translate3d(0px, 0px, 0px) scale(${state.scale})`;
//   applyTransform(); // clamp immediately

//   el.addEventListener('pointerdown', onPointerDown, { passive: true });
//   el.addEventListener('pointermove', onPointerMove, { passive: true });
//   el.addEventListener('pointerup', onPointerUp, { passive: true });
//   el.addEventListener('pointercancel', onPointerUp, { passive: true });
//   el.addEventListener('pointerleave', onPointerUp, { passive: true });
//   el.addEventListener('wheel', onWheel, { passive: false });
// })();
// (() => {
//   const modal = document.querySelector('product-modal');
//   const el = document.querySelector('.product-media-modal__content-mobile');
//   const container = el?.parentElement;
//   if (!modal || !el || !container) return;

//   // ---------- CONFIG ----------
//   const BASE_SCALE = 1.2;            // default zoom
//   const MAX_SCALE  = 4;
//   const MIN_SCALE  = 1;
//   const CLOSE_EPS  = 0.02;           // hysteresis: must go below 1.18 to qualify
//   const CLOSE_DWELL_MS = 160;        // must stay below threshold this long
//   // -----------------------------

//   const state = { x: 0, y: 0, scale: BASE_SCALE, minScale: MIN_SCALE, maxScale: MAX_SCALE };

//   // close guards
//   let belowSince = 0;                // timestamp when we went below threshold
//   let wasZoomingOut = false;         // true if this gesture trend was outward
//   let wheelDebounce;                 // to detect wheel "end"

//   // helpers
//   const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
//   const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
//   const threshold = () => BASE_SCALE - CLOSE_EPS;

//   function containerRect(){ return container.getBoundingClientRect(); }
//   function baseSize(){ return { w: el.offsetWidth, h: el.offsetHeight }; }

//   function clampToBounds(next = { x: state.x, y: state.y, scale: state.scale }) {
//     const { width: cw, height: ch } = containerRect();
//     const { w: bw, h: bh } = baseSize();
//     const sw = bw * next.scale, sh = bh * next.scale;

//     if (sw <= cw) next.x = (cw - sw) / 2;
//     else next.x = clamp(next.x, cw - sw, 0);

//     if (sh <= ch) next.y = (ch - sh) / 2;
//     else next.y = clamp(next.y, ch - sh, 0);

//     return next;
//   }

//   let rafId = null;
//   function applyTransform(){
//     rafId = null;
//     const c = clampToBounds();
//     state.x = c.x; state.y = c.y;
//     el.style.transform = `translate3d(${state.x.toFixed(3)}px, ${state.y.toFixed(3)}px, 0px) scale(${state.scale.toFixed(5)})`;
//   }
//   function scheduleApply(){ if (!rafId) rafId = requestAnimationFrame(applyTransform); }

//   function zoomAroundCenter(nextScale){
//     const rect = containerRect();
//     const cx = rect.left + rect.width  / 2;
//     const cy = rect.top  + rect.height / 2;
//     const scaleFactor = nextScale / state.scale || 1;
//     const newX = cx - scaleFactor * (cx - state.x);
//     const newY = cy - scaleFactor * (cy - state.y);
//     state.scale = nextScale;
//     const c = clampToBounds({ x: newX, y: newY, scale: state.scale });
//     state.x = c.x; state.y = c.y;
//     scheduleApply();

//     // update close guards
//     if (state.scale < threshold()) {
//       if (!belowSince) belowSince = performance.now();
//     } else {
//       belowSince = 0;
//     }
//   }

//   // -------- gestures --------
//   const pointers = new Map();
//   const start = { x: 0, y: 0, scale: BASE_SCALE, dist: 0, panX: 0, panY: 0 };

//   function onPointerDown(e){
//     el.setPointerCapture(e.pointerId);
//     pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

//     if (pointers.size === 1){
//       start.x = state.x; start.y = state.y;
//       start.panX = e.clientX; start.panY = e.clientY;
//       // reset close guards for a new gesture
//       wasZoomingOut = false; belowSince = 0;
//     } else if (pointers.size === 2){
//       start.x = state.x; start.y = state.y; start.scale = state.scale;
//       const [p1, p2] = [...pointers.values()];
//       start.dist = dist(p1, p2);
//       wasZoomingOut = false; belowSince = 0;
//     }
//   }

//   function onPointerMove(e){
//     if (!pointers.has(e.pointerId)) return;
//     pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

//     if (pointers.size === 1){
//       const p = [...pointers.values()][0];
//       const nx = start.x + (p.x - start.panX);
//       const ny = start.y + (p.y - start.panY);
//       const c = clampToBounds({ x: nx, y: ny, scale: state.scale });
//       state.x = c.x; state.y = c.y;
//       scheduleApply();
//     } else if (pointers.size >= 2){
//       const [p1, p2] = [...pointers.values()];
//       const currentDist = Math.max(1, dist(p1, p2));
//       if (!start.dist) start.dist = currentDist;

//       const rawScale = start.scale * (currentDist / start.dist);
//       const newScale = clamp(rawScale, state.minScale, state.maxScale);

//       // track intent: zooming-out if newScale < start.scale by a bit
//       if (newScale < start.scale - 0.01) wasZoomingOut = true;

//       zoomAroundCenter(newScale);
//       // NOTE: we do NOT close here; we wait until gesture ends.
//     }
//   }

//   function onPointerUp(e){
//     if (pointers.has(e.pointerId)) pointers.delete(e.pointerId);

//     if (pointers.size === 1){
//       const p = [...pointers.values()][0];
//       start.x = state.x; start.y = state.y;
//       start.panX = p.x; start.panY = p.y;
//     } else if (pointers.size === 2){
//       start.x = state.x; start.y = state.y; start.scale = state.scale;
//       const [a,b] = [...pointers.values()];
//       start.dist = dist(a,b);
//     }

//     // When all fingers are up, decide about closing with debounce + intent
//     if (pointers.size === 0){
//       const now = performance.now();
//       const stayedBelow = belowSince && (now - belowSince) >= CLOSE_DWELL_MS;
//       if (wasZoomingOut && stayedBelow && state.scale < threshold()) {
//         closeProductModal();
//       } else {
//         // reset guards for next gesture
//         wasZoomingOut = false; belowSince = 0;
//       }
//     }
//   }

//   // wheel/trackpad: close only after wheel "ends" and conditions meet
//   function onWheel(e){
//     if (!e.ctrlKey && Math.abs(e.deltaY) < 1) return;
//     e.preventDefault();

//     const zoomFactor = 0.0015;
//     const target = clamp(state.scale * (1 - e.deltaY * zoomFactor), state.minScale, state.maxScale);
//     if (target < state.scale - 0.005) wasZoomingOut = true; // intent
//     zoomAroundCenter(target);

//     clearTimeout(wheelDebounce);
//     wheelDebounce = setTimeout(() => {
//       const now = performance.now();
//       const stayedBelow = belowSince && (now - belowSince) >= CLOSE_DWELL_MS;
//       if (wasZoomingOut && stayedBelow && state.scale < threshold()) {
//         closeProductModal();
//       }
//       wasZoomingOut = false; belowSince = 0;
//     }, 140);
//   }

//   function closeProductModal(){
//     if (modal.__closing) return;
//     modal.__closing = true;
//     el.style.transition = 'transform 0.2s ease-out, opacity 0.2s ease-out';
//     el.style.opacity = '0';
//     el.style.transform = 'translate3d(0,0,0) scale(0.92)';
//     setTimeout(() => {
//       modal.removeAttribute('open');
//       el.style.transition = ''; el.style.opacity = ''; el.style.transform = '';
//       modal.__closing = false;
//     }, 200);
//   }

//   // init
//   el.style.transform = `translate3d(0px, 0px, 0px) scale(${BASE_SCALE})`;
//   applyTransform();

//   el.addEventListener('pointerdown', onPointerDown, { passive: true });
//   el.addEventListener('pointermove', onPointerMove, { passive: true });
//   el.addEventListener('pointerup', onPointerUp, { passive: true });
//   el.addEventListener('pointercancel', onPointerUp, { passive: true });
//   el.addEventListener('pointerleave', onPointerUp, { passive: true });
//   el.addEventListener('wheel', onWheel, { passive: false });
// })();
(() => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;

  // Prevent double init
  if (modal.__pzInit) return;
  modal.__pzInit = true;

  // ---------- CONFIG ----------
  const BASE_SCALE = 1.2;     // default zoom on open
  const MAX_SCALE  = 4;
  const MIN_SCALE  = 1;       // min operational zoom
  const CLOSE_EPS  = 0.02;    // must intend to go below MIN - EPS
  const CLOSE_DWELL_MS = 160; // must sustain intent this long
  // ----------------------------

  let el, container;
  let state, start, pointers, rafId;
  let belowSince = 0;     // when raw scale first went below MIN - EPS
  let wasZoomingOut = false;
  let wheelDebounce;

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

  function containerRect(){ return container.getBoundingClientRect(); }
  function baseSize(){ return { w: el.offsetWidth, h: el.offsetHeight }; }

  function clampToBounds(next = { x: state.x, y: state.y, scale: state.scale }) {
    const { width: cw, height: ch } = containerRect();
    const { w: bw, h: bh } = baseSize();
    const sw = bw * next.scale, sh = bh * next.scale;

    if (sw <= cw) next.x = (cw - sw) / 2;
    else next.x = clamp(next.x, cw - sw, 0);

    if (sh <= ch) next.y = (ch - sh) / 2;
    else next.y = clamp(next.y, ch - sh, 0);

    return next;
  }

  function applyTransform(){
    rafId = null;
    const c = clampToBounds();
    state.x = c.x; state.y = c.y;
    el.style.transform = `translate3d(${state.x.toFixed(3)}px, ${state.y.toFixed(3)}px, 0px) scale(${state.scale.toFixed(5)})`;
  }
  function scheduleApply(){ if (!rafId) rafId = requestAnimationFrame(applyTransform); }

  function zoomAroundCenter(nextScale){
    const rect = containerRect();
    const cx = rect.left + rect.width  / 2;
    const cy = rect.top  + rect.height / 2;
    const scaleFactor = nextScale / state.scale || 1;
    const newX = cx - scaleFactor * (cx - state.x);
    const newY = cy - scaleFactor * (cy - state.y);
    state.scale = nextScale;
    const c = clampToBounds({ x: newX, y: newY, scale: state.scale });
    state.x = c.x; state.y = c.y;
    scheduleApply();
  }

  // ---------- CLOSE: based on RAW (unclamped) intent ----------
  function markCloseIntent(rawScale, nowTs){
    const closeZone = MIN_SCALE - CLOSE_EPS;
    if (rawScale < closeZone) {
      if (!belowSince) belowSince = nowTs || performance.now();
    } else {
      belowSince = 0;
    }
  }

  function maybeCloseOnGestureEnd(){
    const now = performance.now();
    const closeZone = MIN_SCALE - CLOSE_EPS;
    const stayedBelow = belowSince && (now - belowSince) >= CLOSE_DWELL_MS;
    if (wasZoomingOut && stayedBelow) {
      // final guard: if current (clamped) scale is at or near MIN, treat as intention to close
      closeProductModal();
    }
    wasZoomingOut = false; belowSince = 0;
  }

  // ---------- GESTURES ----------
  function bindGestureHandlers(){
    el.addEventListener('pointerdown', onPointerDown, { passive: true });
    el.addEventListener('pointermove', onPointerMove, { passive: true });
    el.addEventListener('pointerup', onPointerUp, { passive: true });
    el.addEventListener('pointercancel', onPointerUp, { passive: true });
    el.addEventListener('pointerleave', onPointerUp, { passive: true });
    el.addEventListener('wheel', onWheel, { passive: false });
  }
  function unbindGestureHandlers(){
    el.removeEventListener('pointerdown', onPointerDown);
    el.removeEventListener('pointermove', onPointerMove);
    el.removeEventListener('pointerup', onPointerUp);
    el.removeEventListener('pointercancel', onPointerUp);
    el.removeEventListener('pointerleave', onPointerUp);
    el.removeEventListener('wheel', onWheel);
  }

  function onPointerDown(e){
    el.setPointerCapture(e.pointerId);
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

    if (pointers.size === 1){
      start.x = state.x; start.y = state.y;
      start.panX = e.clientX; start.panY = e.clientY;
      wasZoomingOut = false; belowSince = 0;
    } else if (pointers.size === 2){
      start.x = state.x; start.y = state.y; start.scale = state.scale;
      const [p1, p2] = [...pointers.values()];
      start.dist = dist(p1, p2);
      wasZoomingOut = false; belowSince = 0;
    }
  }

  function onPointerMove(e){
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

    if (pointers.size === 1){
      const p = [...pointers.values()][0];
      const nx = start.x + (p.x - start.panX);
      const ny = start.y + (p.y - start.panY);
      const c = clampToBounds({ x: nx, y: ny, scale: state.scale });
      state.x = c.x; state.y = c.y;
      scheduleApply();
    } else if (pointers.size >= 2){
      const [p1, p2] = [...pointers.values()];
      const currentDist = Math.max(1, dist(p1, p2));
      if (!start.dist) start.dist = currentDist;

      const rawScale = start.scale * (currentDist / start.dist); // RAW (unclamped)
      const newScale = clamp(rawScale, MIN_SCALE, MAX_SCALE);    // render with clamp

      if (newScale < start.scale - 0.01) wasZoomingOut = true;
      zoomAroundCenter(newScale);

      // decide close intent using RAW scale (so it can be < MIN)
      markCloseIntent(rawScale);
    }
  }

  function onPointerUp(e){
    if (pointers.has(e.pointerId)) pointers.delete(e.pointerId);

    if (pointers.size === 1){
      const p = [...pointers.values()][0];
      start.x = state.x; start.y = state.y;
      start.panX = p.x; start.panY = p.y;
    } else if (pointers.size === 2){
      start.x = state.x; start.y = state.y; start.scale = state.scale;
      const [a,b] = [...pointers.values()];
      start.dist = dist(a,b);
    }

    if (pointers.size === 0){
      maybeCloseOnGestureEnd();
    }
  }

  function onWheel(e){
    // trackpad pinch-zoom gestures often come as ctrl+wheel
    if (!e.ctrlKey && Math.abs(e.deltaY) < 1) return;
    e.preventDefault();

    const zoomFactor = 0.0015;
    const rawTarget = state.scale * (1 - e.deltaY * zoomFactor); // RAW
    const target = clamp(rawTarget, MIN_SCALE, MAX_SCALE);       // render with clamp
    if (target < state.scale - 0.005) wasZoomingOut = true;

    zoomAroundCenter(target);
    markCloseIntent(rawTarget);

    clearTimeout(wheelDebounce);
    wheelDebounce = setTimeout(() => { maybeCloseOnGestureEnd(); }, 140);
  }

  // ---------- CLOSE ----------
  function closeProductModal(){
    if (modal.__closing) return;
    modal.__closing = true;
    el.style.transition = 'transform 0.2s ease-out, opacity 0.2s ease-out';
    el.style.opacity = '0';
    el.style.transform = 'translate3d(0,0,0) scale(0.92)';
    setTimeout(() => {
      // remove listeners to avoid “second open” stuck state
      unbindGestureHandlers();

      // actually close
      modal.removeAttribute('open');

      // cleanup render styles
      el.style.transition = '';
      el.style.opacity = '';
      el.style.transform = '';

      modal.__closing = false;
    }, 200);
  }

  // ---------- OPEN / RESET ----------
  function resetOnOpen(){
    // get fresh elements (in case DOM changed)
    el = modal.querySelector('.product-media-modal__content-mobile');
    container = el?.parentElement;
    if (!el || !container) return;

    // state fresh
    state = { x: 0, y: 0, scale: BASE_SCALE };
    start = { x: 0, y: 0, scale: BASE_SCALE, dist: 0, panX: 0, panY: 0 };
    pointers = new Map();
    rafId = null;
    belowSince = 0;
    wasZoomingOut = false;

    // initial transform & apply (clamps to center)
    el.style.transform = `translate3d(0px, 0px, 0px) scale(${BASE_SCALE})`;
    // delay one frame so sizes are correct
    requestAnimationFrame(() => { applyTransform(); });

    // (re)bind handlers
    bindGestureHandlers();
  }

  // observe modal open/close to re-init each time
  const mo = new MutationObserver((entries) => {
    for (const m of entries) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        if (modal.hasAttribute('open')) {
          resetOnOpen();
        } else {
          // closed externally—clean listeners
          if (el) unbindGestureHandlers();
          belowSince = 0; wasZoomingOut = false;
        }
      }
    }
  });
  mo.observe(modal, { attributes: true });

  // If it's already open on first load, init once
  if (modal.hasAttribute('open')) resetOnOpen();
})();


